import { render, staticRenderFns } from "./dataV3.vue?vue&type=template&id=3df62e66&scoped=true&"
import script from "./dataV3.vue?vue&type=script&lang=js&"
export * from "./dataV3.vue?vue&type=script&lang=js&"
import style0 from "./dataV3.vue?vue&type=style&index=0&id=3df62e66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df62e66",
  null
  
)

export default component.exports